import 'COMMON';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import { oLike } from 'Lib/like/like';
import 'Lib/js-anchor-link/js-anchor-link';
import 'Bem/journal/test/test';
import 'Bem/journal/test-images/test-images';
import 'Bem/journal/articles/articles';
import 'Bem/journal/article-t/article-t';
import 'Bem/journal/article-share/article-share';
import 'Bem/site/promo/promo';
import 'Bem/site/books-slider/books-slider';
import 'Bem/site/book/book';
import 'Bem/site/journal-articles/journal-articles';
import { Reactions } from 'Lib/reactions/reactions';

const reactions = new Reactions(document.querySelectorAll('.reactions'));

reactions.init();
svgSpriteLoader('/journal/test/svg/sprite.svg?v=20180320');
oLike.init('.js-article-like, .js-book-like, .js-book-basket-like');